import {Router} from '@angular/router';
import * as _ from 'underscore';
import {Component, OnInit, AfterViewInit} from '@angular/core';
import {IOption} from 'ng-select';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {DataService} from '../../shared/data.service';
import {FourthTab} from '../../shared/classes/fourth-tab.model';
import {FormDataService} from '../../shared/form-data.service';
import {
  CourierResponse,
  AvailableCourier,
  AvailableCourierDates,
  AvailableCourierResponse, AvailableCourierDatesResponse
} from '../../shared/classes/courier.model';
import {RightSideService} from '../../shared/right-side.service';
import {NavigationBarService} from '../../shared/navigation-bar.service';
import {storageFactory, detectmob} from '../../../../app-storage';
import {PageContent} from '../../shared/classes/page-content.model';
import hbusApiClient from '../../../../analytics/hbusApiClient';

@Component({
  selector: 'app-fourth-tab',
  templateUrl: './fourth-tab.component.html',
  styleUrls: ['./fourth-tab.component.css'],
  host: {
    class: 'col-md-9 col-lg-9 col-sm-12 col-12'
  }
})
export class FourthTabComponent implements OnInit, AfterViewInit {
  tabSelected = 4;
  errorTexts: string[] = [];
  deliveryForm: FormGroup;
  delivery: FourthTab = new FourthTab();
  lastSeller: any;
  lastSellerCity: any;
  lastSellerDistrict: any;
  serviceError = false;
  isValid = false;
  pageContent: PageContent;
  cashbackEnabled = false;
  isShownIBAN = false;
  isIOS: boolean;
  isAuth: boolean;
  isAuthWarning = false;
  shopperId: string;
  shopperEmail: string;
  orders: Array<IOption> = [];
  categoryName: string;
  brandName: string;
  modelName: string;
  cashbackSelected = false;
  productPrice: number;
  availableCourier: AvailableCourierResponse;
  availableCourierDates: AvailableCourierDatesResponse;
  isPendingHomeDelivery = true;
  isAvailableHomeDelivery = false;
  country = 'Türkiye';
  quantity = 1;
  isSendProposalData = false;

  constructor(
    private fb: FormBuilder,
    private dataService: DataService,
    private formDataService: FormDataService,
    private rightSideService: RightSideService,
    private router: Router,
    private navBarService: NavigationBarService
  ) {
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
    this.categoryName = this.rightSideService.getCategoryName();
    this.brandName = this.rightSideService.getBrandName();
    this.productPrice = this.rightSideService.getPrice();
    this.modelName = this.rightSideService.getModelName();
    this.cashbackSelected = this.rightSideService.getCashbackSelected();
    this.pageContent = this.rightSideService.getPageContent();
    this.isAuth = this.rightSideService.getIsAuth();
    this.shopperId = this.rightSideService.getShopperId();
    this.shopperEmail = this.rightSideService.getShopperEmail();
    this.isAuthWarning = this.rightSideService.getIsAuthWarning();
    this.rightSideService.pageContentChange.subscribe(() => {
      this.pageContent = this.rightSideService.getPageContent();
    });
    this.cashbackEnabled = this.rightSideService.getCashbackEnabled();
    this.rightSideService.cashbackEnabledChange.subscribe(val => {
      this.cashbackEnabled = this.rightSideService.getCashbackEnabled();
    });

    if (this.rightSideService.isResultViewed) {
      this.navBarService.clear();
      this.router.navigate(['/']);
    }
    this.lastSeller = this.formDataService.getSeller();
    this.lastSellerCity = JSON.parse(this.lastSeller.city);
    this.lastSellerDistrict = JSON.parse(this.lastSeller.district);
  }

  ngOnInit() {
    this.createDeliveryForm();

    const seller = this.formDataService.getSeller();
    const merchant = this.rightSideService.getMerchantInfo().buyerInfo;

    const city = JSON.parse(seller.city);
    const district = JSON.parse(seller.district);
    const town = JSON.parse(seller.town);

    const sellerAddress = {
      country: this.country,
      city: city.name,
      district: town.name,
      town: district.name
    };
    const merchantAddress = {
      country: this.country,
      city: merchant.city,
      district: merchant.town,
      town: merchant.district,
    };
    const products = [
      {
        deci: this.rightSideService.getDeci(),
        quantity: this.quantity,
      }
    ];
    this.getAvailableCourier({
      senderAddress: sellerAddress,
      receiverAddress: merchantAddress,
      products: products,
    }, () => {
      this.getAvailableCourierDates({
        cargoFirmId: this.rightSideService.getAvailableCourier().cargoOption.id,
        senderAddress: sellerAddress,
      });
    });
  }

  ngAfterViewInit() {
    if (this.tabSelected !== 5) {
      const elmnt = document.getElementById('navHead');
      const isMobile = detectmob();
      if (isMobile) {
        if (!navigator.userAgent.match(/safari/i) || localStorage == null) {
          // safari || android webview
          parent.postMessage({
            scrollY: (elmnt.getBoundingClientRect().top + this.rightSideService.getTopHeight())
          }, '*');
        } else {
          // ios safari || android tarayıcı
          parent.postMessage({
            scrollY: (elmnt.getBoundingClientRect().top + this.rightSideService.getTopHeight())
          }, '*');
        }
      } else {
        parent.postMessage({
          scrollY: (elmnt.getBoundingClientRect().top + this.rightSideService.getTopHeight())
        }, '*');
      }
    }
  }

  createDeliveryForm() {
    this.deliveryForm = this.fb.group({
      deliveryType: ['', [Validators.required]],
      homeDeliveryAvailableCourierSelectedDate: ['', [Validators.required]],
      homeDeliveryCourierId: ['', [Validators.required]],
    });
  }

  setHomeDeliveryStatus() {
    this.isPendingHomeDelivery = false;

    const isAvailable = Boolean(this.availableCourier && this.availableCourierDates);
    this.deliveryForm.patchValue({
      deliveryType: isAvailable ? 'homeDelivery' : 'courierOfficeDelivery',
    });
    this.isAvailableHomeDelivery = isAvailable;
  }

  getAvailableCourier(payload: AvailableCourier, callback: Function) {
    return this.dataService.getAvailableCourier(payload).subscribe(
      (res: any) => {
        if (res && res.cargoOption) {
          this.serviceError = false;
          this.availableCourier = res;
          this.rightSideService.setAvailableCourier(this.availableCourier);

          this.deliveryForm.patchValue({
            homeDeliveryCourierId: this.availableCourier.cargoOption.id,
          });

          if (callback) {
            callback();
          }
        } else {
          this.setHomeDeliveryStatus();
        }
      }, error => {
        this.setHomeDeliveryStatus();
      }
    );
  }

  getAvailableCourierDates(payload: AvailableCourierDates) {
    return this.dataService.getAvailableCourierDates(payload).subscribe(
      (res: any) => {
        if (res) {
          this.serviceError = false;
          this.availableCourierDates = res.slice(0, 3);
          this.rightSideService.setAvailableCourierDates(this.availableCourierDates);

          this.deliveryForm.patchValue({
            homeDeliveryAvailableCourierSelectedDate: this.availableCourierDates[0].claimDate,
          });
        } else {
          this.serviceError = true;
          res.errorMessages.forEach(err => {
            this.checkErrorExist(err, this.errorTexts);
          });
        }
      }, error => {
        this.serviceError = true;
        error.errorMessages.forEach(err => {
          this.checkErrorExist(err, this.errorTexts);
        });
      }, () => {
        this.setHomeDeliveryStatus();
      }
    );
  }

  submitForm() {
    if (this.deliveryForm.value.deliveryType === 'homeDelivery') {
      if (this.deliveryForm.valid) {
        this.isValid = true;
        this.applyProposalLogics();
      } else {
        this.isValid = false;
        this.validateAllFormFields(this.deliveryForm);
      }
    } else {
      this.applyProposalLogics();
    }
  }

  applyProposalLogics() {
    this.delivery = this.deliveryForm.value;
    this.formDataService.setFourthTab(this.delivery);

    const query = this.isShownIBAN ? 'cashback' : 'buyback';
    this.isSendProposalData = true;
    this.dataService.getPageContents(this.rightSideService.selectedCategoryId, query)
      .subscribe((res: PageContent) => {
        this.rightSideService.setPageContent(res);
      }, error => {
        error.errorMessages.forEach(err => {
          this.errorTexts.push(err);
        });
      });
    this.dataService.postProposal(this.formDataService.getFormData()).subscribe(
      (res: any) => {
        if (res && res.success) {
          this.serviceError = false;
          const courierData: CourierResponse = res.data;
          this.rightSideService.setCourier(courierData);
          this.navBarService.setSelectedTab(this.tabSelected + 1);
          this.sendDavinciEvent('onayla');
          this.router.navigate(['/sonuc']);
        } else {
          this.serviceError = true;
          res.errorMessages.forEach(err => {
            this.checkErrorExist(err, this.errorTexts);
          });
        }
      }, error => {
        this.serviceError = true;
        error.errorMessages.forEach(err => {
          this.checkErrorExist(err, this.errorTexts);
        });
      }, () => {
        this.isSendProposalData = false;
      }, 
    );
  }

  checkErrorExist(errorText: string, errorList: string[]) {
    if (!_.contains(errorList, errorText)) {
      errorList.push(errorText);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  previousPage() {
    this.navBarService.setSelectedTab(this.tabSelected - 1);
    this.sendDavinciEvent('önceki');
    this.router.navigate(['/iletisim-bilgileri']);
  }

  sendDavinciEvent(buttonName) {
    const isCourierOfficeDelivery = this.deliveryForm.value.deliveryType === 'courierOfficeDelivery';

    try {
      hbusApiClient.sendEventRequest('DeliverySteps', {
        page_type: 'static',
        page_value: 'eskiyi-getir-yeniyi-gotur',
        stepNo: 4,
        stepName: 'teslimatAdimlari',
        paymentOptions: this.cashbackSelected ? 'cash' : 'coupon',
        brand: this.brandName || '',
        model: this.modelName || '',
        deliverytype: isCourierOfficeDelivery ? 'isNotHomeDelivery' : 'homeDelivery',
        claimdate: isCourierOfficeDelivery ? '' : this.deliveryForm.value.homeDeliveryAvailableCourierSelectedDate,
        proposedAmount: this.productPrice ?
          // tslint:disable-next-line:radix
          `${parseInt(this.productPrice.toString()).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
          : '',
        buyBackCategory: this.categoryName || '',
        clickButtonInfo: buttonName,
      });
    } catch (e) {
      console.error('error send event', e.message);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/tabs/fourth-tab/fourth-tab.component.ts